module.exports = __webpack_public_path__ + "img/campanas.db615371.png";